import { MenuProps } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDisclosure } from "../../../../../hooks/useDisclosure";
import { Booking } from "../../../../../types/bookings";
import { ActionDropdown } from "../../../../organism";
import { TerminateLease } from "./EarlyTermination/TerminateLease";
import { LeaseTermAmendment } from "./LeaseAmendments/LeaseTermAmendment";
import { PaymentPlanAmendment } from "./LeaseAmendments/PaymentPlanAmendment";
import { RenewalTermAmendment } from "./LeaseAmendments/RenewalTermAmendment";
import { TenantAmendments } from "./LeaseAmendments/TenantAmendments";

type LeaseActionDropdownProps = {
  items: MenuProps["items"];
};

export const LeaseActionDropdown = (props: LeaseActionDropdownProps) => {
  const { items } = props;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedItem, setSelectedItem] = useState(null);

  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const { leaseType } = (bookingDetails || {}) as Booking;

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    const key = e.key;

    setSelectedItem(key);
    onOpen();
  };

  return (
    <ActionDropdown key={selectedItem} buttonLabel="Lease Actions" items={items} onMenuClick={handleMenuClick}>
      {selectedItem === "terminate" && <TerminateLease isOpen={isOpen} onClose={onClose} />}
      {selectedItem === "leaseTermAmendment" && <LeaseTermAmendment isOpen={isOpen} onClose={onClose} />}
      {selectedItem === "paymentScheduleAmendments" && (
        <LeaseTermAmendment paymentScheduleAmendments={selectedItem} isOpen={isOpen} onClose={onClose} />
      )}
      {selectedItem === "TenantAmendments" && <TenantAmendments isOpen={isOpen} onClose={onClose} />}
      {selectedItem === "leaseTermAmendment" && leaseType === "renewal" && (
        <RenewalTermAmendment isOpen={isOpen} onClose={onClose} />
      )}
      {selectedItem === "paymentPlanAmendments" && <PaymentPlanAmendment isOpen={isOpen} onClose={onClose} />}
    </ActionDropdown>
  );
};
